import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  /* 🔹 Hack para ocupar todo el ancho aunque esté dentro de un Container */
  position: relative;
  width: 100vw;
  margin-left: calc(50% - 50vw);

  background: #f3f4f6;
  border-top: 1px solid rgba(148, 163, 184, 0.25);
  box-shadow: 0 -2px 6px rgba(15, 23, 42, 0.06);
`;

const FooterInner = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 24px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (max-width: 768px) {
    padding: 20px 16px;
  }
`;

const FooterText = styled.p`
  font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.8rem;
  color: rgba(55, 65, 81, 0.85);
`;

function Footer() {
  const year = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterInner>
        <FooterText>
          © {year} GIMAV Picture. Todos los derechos reservados.
        </FooterText>
      </FooterInner>
    </FooterContainer>
  );
}

export default Footer;
